module.exports = EntryTool;